/**
 * Enhanced Product Card Form Handler
 */

if (!customElements.get('product-card-enhanced-form')) {
  customElements.define(
    'product-card-enhanced-form',
    class ProductCardEnhancedForm extends HTMLElement {
      async fetchCart() {
        try {
          const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
          if (!res.ok) return null;
          return await res.json();
        } catch (_e) {
          return null;
        }
      }

      constructor() {
        super();
        this.form = this.querySelector('form');
        this.button =
          this.querySelector('.product-card-enhanced__quick-add') ||
          this.querySelector('.product-card-enhanced__atc');
        this.loadingSpinner =
          this.querySelector('.product-card-enhanced__quick-add-loading') ||
          this.querySelector('.product-card-enhanced__atc-loading');
        this.buttonText =
          this.querySelector('.product-card-enhanced__quick-add-text') ||
          this.querySelector('.product-card-enhanced__atc-text');

        if (this.form) {
          this.form.addEventListener('submit', this.onSubmit.bind(this));
        }
      }

      async onSubmit(event) {
        event.preventDefault();

        if (!this.button || this.button.disabled) {
          return;
        }

        const formData = new FormData(this.form);
        const variantId = formData.get('id');

        if (!variantId) {
          console.error('No variant ID found');
          return;
        }

        this.setLoadingState(true);

        try {
          const baseUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
          const url = baseUrl.endsWith('.js') ? baseUrl : `${baseUrl}.js`;

          const res = await fetch(url, {
          method: 'POST',
          body: formData,
            headers: { Accept: 'application/json' },
          });

          const data = await res.json().catch(() => null);

          // Only treat as error if Shopify explicitly returns an error payload or HTTP not-ok
          if (!res.ok || (data && data.status)) {
            throw new Error((data && (data.description || data.message)) || 'Failed to add to cart');
          }

          // Success UI immediately; cart UI updates are best-effort and must not flip to Error
            this.setLoadingState(false);
            this.showSuccess();

          const cartData = await this.fetchCart();
          this.updateCartUI(cartData || data);

            if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-card-enhanced',
                productVariantId: variantId,
              cartData: cartData || data,
              });
            }
        } catch (error) {
            console.error('Error adding to cart:', error);
            this.setLoadingState(false);
          this.showError(error && error.message ? error.message : 'Failed to add to cart');
          if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-card-enhanced',
              productVariantId: variantId,
              errors: error && error.message ? error.message : error,
              message: error && error.message ? error.message : 'Failed to add to cart',
            });
          }
        }
      }

      setLoadingState(isLoading) {
        if (!this.button) return;

        if (isLoading) {
          this.button.disabled = true;
          if (this.buttonText) this.buttonText.classList.add('hidden');
          if (this.loadingSpinner) this.loadingSpinner.classList.remove('hidden');
        } else {
          this.button.disabled = false;
          if (this.buttonText) this.buttonText.classList.remove('hidden');
          if (this.loadingSpinner) this.loadingSpinner.classList.add('hidden');
        }
      }

      showError(message) {
        const originalText = this.buttonText ? this.buttonText.textContent : '';
        if (this.buttonText) {
          this.buttonText.textContent = 'Error';
          setTimeout(() => {
            if (this.buttonText) this.buttonText.textContent = originalText;
          }, 2000);
        }
      }

      showSuccess() {
        const originalText = this.buttonText ? this.buttonText.textContent : '';
        if (this.buttonText) {
          this.buttonText.textContent = 'Added!';
          setTimeout(() => {
            if (this.buttonText) this.buttonText.textContent = originalText;
          }, 2000);
        }
      }

      updateCartUI(cartData) {
        try {
          // Update cart drawer/notification if available
          const cartDrawer = document.querySelector('cart-drawer');
          const cartNotification = document.querySelector('cart-notification');
          if (cartDrawer && cartData) cartDrawer.renderContents(cartData);
          if (cartNotification && cartData) cartNotification.renderContents(cartData);
        } catch (_e) {
          // ignore UI render errors
        }

        // Update cart count if available
        if (cartData && cartData.item_count !== undefined) {
          const cartCountElements = document.querySelectorAll('.cart-count-bubble, [data-cart-count]');
          cartCountElements.forEach((el) => {
            el.textContent = cartData.item_count;
          });
        }
      }
    }
  );
}

